import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import InputLabel from "@material-ui/core/InputLabel";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Input from "@material-ui/core/Input";
import CardActions from "@material-ui/core/CardActions";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import CircularProgress from "@material-ui/core/CircularProgress";
import Card from "@material-ui/core/Card";
import Typography from "@material-ui/core/Typography";
import { Link, Redirect, withRouter } from "react-router-dom";
import * as actions from "../../store/actions/index";
import { connect } from "react-redux";
import CardContent from "@material-ui/core/CardContent";
import PropTypes from "prop-types";
import PrimaryAppBar from "../../components/PrimaryAppBar";
import ChangeLangaugeMenu from "../../components/ChangeLanguageMenu";
import Footer from "../Footer/Footer";
import withSizes from "react-sizes";
import leftIcon from "../../images/left.png";
import logo from "../../images/logo.png";
import axios from 'axios';

const styles = (theme) => ({
  container: {
    /*==display: 'flex',
      flexWrap: 'wrap',*/
    fontSize: "16px",
  },
  margin: {
    margin: theme.spacing.unit,
    fontSize: "16px",
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: "100%",
    fontSize: "16px",
    //flexBasis: 200,
  },
  dense: {
    marginTop: 19,
    fontSize: "16px",
  },
  card: {
    //position: 'relative',
    // minWidth: 200,
    width: "auto",
    fontSize: "16px",
    // marginRight: 6,
    //maxWidth: '25%',
    marginTop: "20px",
    //float:'right',
  },
  cardContent: {
    margin: "auto",
    padding: "0",
    fontSize: "16px",
  },
  menu: {
    width: "100%",
    fontSize: "16px",
  },
  form: {
    padding: "0 1em 1em 1em",
    fontSize: "18px",
  },
  input: {
    marginTop: "1em",
    fontSize: "18px",
  },
  bInput: {
    background: "rgba(255, 255, 255, 0.5)",
    outline: "0",
    color: "#99192D",
    wordWrap: "break-word",
    wordBreak: "break-word",
    border: "2px solid #99192D",
    paddingTop: "15px",
    textTransform: 'none',
    paddingBottom: "15px",
    borderRadius: "25px",
    // height: "30px",
    marginLeft: "3px",
    marginRight: "3px",
    boxSizing: "border-box",
    fontSize: "16px",
    "&:hover": {
      color: "white",
    },
  },
  link: {
    textDecoration: "none",
    fontSize: "16px",
    // pointerEvents: 'none',
  },
  cardAction: {
    justifyContent: "right",
    fontSize: "16px",
  },
  notify: {
    justifyContent: "center",
    alignText: "center",
    fontSize: "16px",
  },
  resize: {
    fontSize: 14,
  },
  labelRoot: {
    fontSize: 14,
  },
});

class LoginForm extends Component {
  state = {
    username: "",
    password: "",
    twoFaCode: "",
    showPassword: false,
    loginInProgress: false,
    windowHeight: undefined,
    windowWidth: undefined,
    verifyFalse: true,
    resend: false
  };

  performLogin = (event) => {};

  handleChange = (prop) => (event) => {
    this.setState({ [prop]: event.target.value });
  };

  handleClickShowPassword = () => {
    this.setState((state) => ({ showPassword: !state.showPassword }));
  };

  submitHandler = (event, method = 'email') => {
    console.log('submitHandler', method)
    event.preventDefault();
    this.setState({ resend: true }); 
    if(method == 'sms'){
      setTimeout(() => {
        this.setState({ resend: false });
      }, 60000)
    }
    this.props.onAuth(this.state.username, this.state.password, method, true);
    
    //this.props.history.push(this.props.authRedirect);
  };

  componentWillReceiveProps(props) {
    this.setState({ loginInProgress: props.loginInProgress });
  }

  handleResize = () => {
    this.setState({
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
    });
    this.innerWidth = window.innerWidth;
    console.log(
      "Window Size: window.innerHeight: " +
        window.innerHeight +
        " window.innerWidth: " +
        window.innerWidth +
        " div 4: " +
        window.innerWidth / 4
    );
  };

  componentDidMount() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  }

  handleClick() {
    this.props.history.push(`/`)
  }

  verify2fa(twoFaCode) {
      console.log('verify2fa', twoFaCode)
      let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/verify2fa`;
      const verifyData = {
          code: twoFaCode,
          username: this.state.username,
          password: this.state.password
      };

      axios.post(url, {
          ...verifyData
      })
      .then((response) => {
          console.log('verify2fa response', response);
          if(response.data == true){
            this.props.updateVerify2CodeToTrue();
          }
          else{
            this.setState({verifyFalse: true})
          }
      })
      .catch((error) => {
          console.log(error);
      });
  }

  render() {
    const { classes, isAuthenticated, error } = this.props;
    const twofa = localStorage.getItem('twofa');
    if (isAuthenticated && twofa) {
      /* return (
          <Redirect to={this.props.authRedirect} />
      ); */
      return <Redirect to="/cases" />;
    } else {
      return (
        <div>
          {!this.props.isMobile && <Grid
            container
            direction="row"
            justify="space-evenly"
            alignItems="flex-start"
          >
            <Grid item xs={12} style={{ textAlign: "center" }}>

              <Button
                onClick={()=>{this.handleClick()}}
                style={{ float: "left" }}
              >
                <img
                  style={{ width: "15%", marginRight: "10px" }}
                  src={leftIcon}
                ></img>
                {this.context.t("Back")}
              </Button>

              <p style={{ textAlign: "left" }}>
                <img src={logo} />
              </p>

            </Grid>
          </Grid> }

          {this.props.isMobile && <Grid
            container
            direction="row"
            justify="space-evenly"
            alignItems="flex-start"
          >
            <Grid item xs={12} style={{ textAlign: "center" }}>

              <Button
                onClick={()=>{this.handleClick()}}
                style={{ float: "left" }}
              >
                <img
                  style={{ width: "15%", marginRight: "10px" }}
                  src={leftIcon}
                ></img>
                {this.context.t("Back")}
              </Button>

            </Grid>
            <Grid item xs={12} style={{ textAlign: "center" }}>

            <p style={{ textAlign: "left" }}>
              <img src={logo} />
            </p>

            </Grid>
          </Grid> }

          <Grid
            container
            direction="row"
            justify="space-evenly"
            alignItems="flex-start"
          >
            <Grid item xs={12} style={{ textAlign: "center" }}>
              <div style={{ textAlign: "center" }}>
                {error ? (
                  <Typography
                    style={{ fontSize: "16px" }}
                    className={classes.notify}
                    color="primary"
                  >
                    {this.context.t("Username or password is incorrect")}
                  </Typography>
                ) : null}
              </div>
            </Grid>

            <Grid item xs={12} style={{ textAlign: "center" }}>
              <div style={{ textAlign: "center" }}>
                {this.props.twofaMethod ? (
                  <Typography
                    style={{ fontSize: "16px" }}
                    className={classes.notify}
                    color="primary"
                  >
                    {this.context.t("Two Factor Auth code sent via ")} {this.props.twofaMethod}
                  </Typography>
                ) : null}
              </div>
            </Grid>

            {/* <Grid item xs={12} style={{ textAlign: "center" }}>
              <div style={{ textAlign: "center" }}>
                {this.state.verifyFalse ? (
                  <Typography
                    style={{ fontSize: "16px" }}
                    className={classes.notify}
                    color="primary"
                  >
                    {this.context.t("2FA Code is incorrect")}
                  </Typography>
                ) : null}
              </div>
            </Grid> */}

            <Grid item xs={12} style={{ textAlign: "center" }}>
              <form onSubmit={this.submitHandler}>
                <div className={classes.form}>
                  <Grid
                    container
                    direction="row"
                    justify="space-evenly"
                    alignItems="flex-start"
                  >
                    <Grid item xs={12} style={{ textAlign: "center", marginTop:'30px' }}>
                      <div
                        className={classes.input}
                        style={{ textAlign: "center" }}
                      >
                        <TextField
                          id="user-name"
                          label={this.context.t("Username")}
                          value={this.state.username}
                          onChange={this.handleChange("username")}
                          margin="normal"
                          style={{
                            width: this.props.isMobile
                              ? "50%"
                              : this.state.windowWidth < 700
                              ? "50%"
                              : "30%",
                          }}
                          InputProps={{
                            classes: {
                              input: classes.resize,
                              style: { fontSize: 16 },
                              shrink: true,
                            },
                          }}
                          InputLabelProps={{
                            style: { fontSize: 16 },
                            shrink: true,
                            FormLabelClasses: {
                              root: classes.labelRoot,
                            },
                          }}
                          disabled={this.state.loginInProgress}
                        />
                      </div>
                    </Grid>

                    <Grid item xs={12} style={{ textAlign: "center" }}>
                      <div
                        className={classes.input}
                        style={{ fontSize: "14px", textAlign: "center" }}
                      >
                        <FormControl
                          style={{
                            fontSize: "14px",
                            width: this.props.isMobile
                              ? "50%"
                              : this.state.windowWidth < 700
                              ? "50%"
                              : "30%",
                          }}
                        >
                          <InputLabel
                            style={{ fontSize: "14px" }}
                            htmlFor="username-password"
                            error={error}
                          >
                            {this.context.t("Password")}
                          </InputLabel>
                          <Input
                            id="username-password"
                            type={this.state.showPassword ? "text" : "password"}
                            value={this.state.password}
                            error={error}
                            onChange={this.handleChange("password")}
                            disabled={this.props.loginInProgress}
                            endAdornment={
                              <InputAdornment position="end">
                                <IconButton
                                  style={{ fontSize: "14px" }}
                                  aria-label="Toggle password visibility"
                                  onClick={this.handleClickShowPassword}
                                >
                                  {this.state.showPassword ? (
                                    <Visibility />
                                  ) : (
                                    <VisibilityOff />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            }
                            inputLabelProps={{
                              style: { fontSize: 14 },
                              shrink: true,
                            }}
                            inputProps={{
                              style: { fontSize: 14 },
                              shrink: true,
                            }}
                          />
                        </FormControl>
                      </div>
                    </Grid>

                    {this.props.twofaMethod !== null && <Grid item xs={12} style={{ textAlign: "center", marginTop:'30px' }}>
                      <div
                        // className={classes.input}
                        style={{ textAlign: "center" }}
                      >
                        <TextField
                          id="user-name"
                          label={this.context.t("2FA Code")}
                          value={this.state.twoFaCode}
                          onChange={this.handleChange("twoFaCode")}
                          margin="normal"
                          style={{
                            width: this.props.isMobile
                              ? "50%"
                              : this.state.windowWidth < 700
                              ? "50%"
                              : "30%",
                          }}
                          InputProps={{
                            classes: {
                              input: classes.resize,
                              style: { fontSize: 16 },
                              shrink: true,
                            },
                          }}
                          InputLabelProps={{
                            style: { fontSize: 16 },
                            shrink: true,
                            FormLabelClasses: {
                              root: classes.labelRoot,
                            },
                          }}
                          disabled={this.state.loginInProgress}
                        />
                      </div>
                    </Grid>}

                    <Grid item xs={12} style={{ textAlign: "center" }}>
                      <div
                        className={classes.input}
                        style={{
                          fontSize: "14px",
                          textAlign: "center", //marginRight:'365px'
                        //   marginRight: 
                        //   this.props.isMobile
                        //     ? this.state.windowWidth < 700
                        //       ? "175px"
                        //       : "365px"
                        //     : this.state.windowWidth < 700
                        //     ? "175px"
                        //     : "365px",
                        }}
                      >
                        <Link to='/forgetPassword' className={classes.link}>
                            <Typography style={{ fontSize: "13px", color:'#99192D' }}>
                            {this.context.t("Forgot Password")}?
                            </Typography>
                        </Link>
                      </div>
                    </Grid>

                    {this.props.twofaMethod == null && <Grid item xs={12} style={{ textAlign: "center" }}>
                      <div style={{ textAlign: "center", marginTop: "20px", marginBottom:'50px' }}>
                        {this.props.loginInProgress ? (
                          <CircularProgress size={25} thickness={2} />
                        ) : (
                          <Button
                            variant="contained"
                            type="submit"
                            color="primary"
                            disabled={this.props.loginInProgress}
                            style={{
                              marginTop:'20px',
                              width: this.props.isMobile
                                ? "50%"
                                : this.state.windowWidth < 700
                                ? "30%"
                                : "10%",
                            }}
                            className={classes.bInput}
                          >
                            {this.state.loginInProgress && (
                              <CircularProgress size={25} thickness={2} />
                            )}
                            {this.context.t("Login")}
                          </Button>
                        )}
                      </div>
                    </Grid>}

                    {this.props.twofaMethod !== null && <Grid item xs={12} style={{ textAlign: "center" }}>
                      <div style={{ textAlign: "center", marginTop: "20px", marginBottom:'50px' }}>
                        {this.props.loginInProgress ? (
                          <CircularProgress size={25} thickness={2} />
                        ) : (
                          <Button
                            onClick={() => this.verify2fa(this.state.twoFaCode)}
                            variant="contained"
                            color="primary"
                            disabled={this.props.loginInProgress}
                            style={{
                              marginTop:'20px',
                              width: this.props.isMobile
                                ? "50%"
                                : this.state.windowWidth < 700
                                ? "30%"
                                : "10%",
                            }}
                            className={classes.bInput}
                          >
                            {this.state.loginInProgress && (
                              <CircularProgress size={25} thickness={2} />
                            )}
                            {this.context.t("Verify")}
                          </Button>
                        )}
                      </div>
                    </Grid>}

                    {this.props.twofaMethod !== null && <Grid item xs={12} style={{ textAlign: "center" }}>
                      <div style={{ textAlign: "center", marginTop: "20px", marginBottom:'50px' }}>
                        {this.props.resend ? (
                          null
                        ) : (
                          <Button
                            onClick={(e) => this.submitHandler(e, 'sms')}
                          >
                            {this.state.loginInProgress && (
                              <CircularProgress size={25} thickness={2} />
                            )}
                            <Typography style={{ fontSize: "13px", color:'#99192D' }}>
                              {this.context.t("Send code by SMS")}
                            </Typography>
                          </Button>
                        )}
                      </div>
                    </Grid>}

                  </Grid>
                </div>
              </form>
            </Grid>
          </Grid>
          {!this.props.isMobile && <Footer />}
        </div>
      );
    }
  }
}

LoginForm.contextTypes = {
  t: PropTypes.func,
};

const mapStateToProps = (state) => {
  console.log(state);
  return {
    loginInProgress: state.auth.loginInProgress,
    isAuthenticated: state.auth.token !== null,
    error: state.auth.error,
    twofaMethod: state.auth.twofaMethod,
    twofa: state.auth.twofa,
    authRedirect: state.auth.authRedirect,
    newAccount: state.auth.newAccount,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onAuth: (username, password, method, autologin) => dispatch(actions.auth(username, password, method, autologin)),
    updateVerify2CodeToTrue: () => dispatch(actions.updateVerify2CodeToTrue()),
    onSetRedirectPath: (path) => dispatch(actions.setAuthRedirect(path)),
  };
};

const mapSizesToProps = (sizes) => ({
  isMobile: withSizes.isMobile(sizes),
  isTablet: withSizes.isTablet(sizes),
  isDesktop: withSizes.isDesktop(sizes),
  isGtMobile: withSizes.isGtMobile(sizes),
  isGtTablet: withSizes.isGtTablet(sizes),
  isStTablet: withSizes.isStTablet(sizes),
  isStDesktop: withSizes.isStDesktop(sizes),
  isTabletAndGreater: withSizes.isTabletAndGreater(sizes),
  isTabletAndSmaller: withSizes.isTabletAndSmaller(sizes),
});

// export default withRouter( connect(mapStateToProps, mapDispatchToProps) (withStyles(styles) (withSizes(mapSizesToProps)) (LoginForm)) ) ;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withSizes(mapSizesToProps)(withStyles(styles)(withRouter(LoginForm))));
